import { TextInput } from '../TextInput/TextInput';
import type { PasswordInputProps } from '../types';
import { PasswordVisibilityToggle } from './components/PasswordVisibilityToggle/PasswordVisibilityToggle';

function PasswordInput({
  id,
  value,
  autoComplete = 'off',
  onChange,
  label,
  topActionElement,
  placeholder,
  helpMessage,
  helpMessageType,
  bottomActionElement,
  isPasswordVisible,
  togglePasswordVisible,
  disabled = false,
  'data-testid': dataTestId = 'password-input',
  ...props
}: PasswordInputProps) {
  return (
    <TextInput
      {...props}
      id={id}
      type={isPasswordVisible ? 'text' : 'password'}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
      label={label}
      topActionElement={topActionElement}
      placeholder={placeholder}
      rightIcon={<PasswordVisibilityToggle isPasswordVisible={isPasswordVisible} togglePasswordVisible={togglePasswordVisible} disabled={disabled} />}
      helpMessage={helpMessage}
      helpMessageType={helpMessageType}
      bottomActionElement={bottomActionElement}
      disabled={disabled}
      data-testid={dataTestId}
    />
  );
}

export { PasswordInput };
